<strong>
    <ng-container *ngId="filter.filterTemplate.group != 'DEFAULT'">
        {{ filter.filterTemplate.group | translate }}
        <i class="fa fa-caret-right"></i>
    </ng-container> {{ filter.filterTemplate.label | translate }}
</strong> {{ filter.value | localizedDate: filter.getMonthYearFilterTemplate().monthYearFormat }}